import { FC } from 'react';
import styled from 'styled-components';
import { WellPrizeLogo } from '../icons';

interface IWellPrizeLink {
  url: string | null;
  size: number;
}

const WellPrizeAnchor = styled('a')`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
`;

// Native SVG aspect ratio (viewBox 102 x 28) — keep it to avoid distortion.
const ASPECT_RATIO = 102 / 28;

const WellPrizeLink: FC<IWellPrizeLink> = ({ url, size }) => {
  const width = size * ASPECT_RATIO;

  if (!url) {
    return <WellPrizeLogo height={size} width={width} />;
  }

  return (
    <WellPrizeAnchor href={url} target="_blank" rel="noreferrer">
      <WellPrizeLogo height={size} width={width} />
    </WellPrizeAnchor>
  );
};

export default WellPrizeLink;
